export enum DataCollectionSource {
  Recollection = 'recollection',
  Onboarding = 'onboarding',
}

export enum PaymentProvider {
  Stitch = 'stitch',
  UsBank = 'us_bank',
}
